export default __webpack_public_path__ + "static/media/express.0f46c964.svg";